
import { TextNode } from 'lexical';

export class ExtendedTextNode extends TextNode {
    static getType() {
        return 'extended-text';
    }

    static clone(node) {
        return new ExtendedTextNode(node.__text, node.__key);
    }

    static importDOM() {
        const importers = TextNode.importDOM();
        const newImporters = {};

        // Wrap all existing importers from TextNode (handles strong, em, span, etc.)
        for (const [tag, importer] of Object.entries(importers)) {
            newImporters[tag] = (domNode) => {
                const result = importer(domNode);
                if (!result) return null;

                return {
                    ...result,
                    conversion: (domNode) => {
                        const output = result.conversion(domNode);
                        if (!output) return null;

                        const style = domNode.style;
                        if (style && style.fontSize) {
                            const fontSizeStyle = `font-size: ${style.fontSize}`;

                            const applyStyle = (node) => {
                                if (node instanceof TextNode) {
                                    // Merge with existing style if any (though usually empty on new import)
                                    node.setStyle(fontSizeStyle);
                                }
                            };

                            if (output.node) {
                                applyStyle(output.node);
                            }

                            if (output.forChild) {
                                const originalForChild = output.forChild;
                                output.forChild = (lexicalNode, parent) => {
                                    const child = originalForChild(lexicalNode, parent);
                                    if (child) {
                                        applyStyle(child);
                                    }
                                    return child;
                                };
                            }
                        }

                        return output;
                    }
                };
            };
        }

        // Explicitly handle span if it wasn't in TextNode importers (it usually is)
        if (!newImporters.span) {
            newImporters.span = (domNode) => {
                const style = domNode.style;
                if (!style || !style.fontSize) return null;
                return {
                    conversion: (node) => {
                        const textNode = new TextNode(node.textContent);
                        textNode.setStyle(`font-size: ${style.fontSize}`);
                        return { node: textNode };
                    },
                    priority: 1
                };
            };
        }

        return newImporters;
    }

    static importJSON(serializedNode) {
        return TextNode.importJSON(serializedNode);
    }

    exportJSON() {
        return {
            ...super.exportJSON(),
            type: 'extended-text',
        };
    }
}

export function $createExtendedTextNode(text) {
    return new ExtendedTextNode(text);
}

export function $isExtendedTextNode(node) {
    return node instanceof ExtendedTextNode;
}
